import React from "react";
import "./styleSheet.css";
import Illustration from "../../Assets/Images/Illustrations/Illustration";
import VisibilitySensor from "react-visibility-sensor";

export default class MainBackground extends React.Component{
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <div className="home-layout-background-division">

                <div className="home-landing-background-header">
                    <Illustration name={"BlueEllipse"} className="hologram-header-image"/>
                </div>
                <div className="home-landing-background">
                    <Illustration name={"NeuralNetwork"} className="hologram-background-image"/>
                    <Illustration name={"GreenEllipse"}
                                  className="hologram-background-image background"/>
                </div>

                <div className="home-landing-background">
                    <VisibilitySensor onChange={this.onVisibilityChange} partialVisibility={true}>
                        <Illustration name={"NeuralNetwork"}
                                      className={this.state.showNeural ? "hologram-background-image" : "hologram-background-image hide"}/>
                    </VisibilitySensor>
                    <Illustration name={"BlueEllipse"}
                                  className="hologram-background-image background"/>
                </div>

                <div className="home-landing-background">
                    <Illustration name={"NeuralNetwork"} className="hologram-background-image"/>
                    <Illustration name={"GreenEllipse"}
                                  className="hologram-background-image background"/>
                </div>
            </div>
        );
    }

}